<div class="card">
  <div class="card-header">
    <h4>{{ 'title.billing' | translate }}</h4>
  </div>
</div>
